import React, { useState } from 'react';
import WarmUpDiscussionExercise from './WarmUpDiscussionExercise';
import './WarmUpDiscussionExerciseBoard.css';

const WARM_UP_DISCUSSION_ICON = (
  <span style={{
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 48, height: 48, borderRadius: 12, background: 'linear-gradient(135deg, #4f46e5 0%, #6366f1 100%)', marginRight: 20, flexShrink: 0
  }}>
    <svg width="28" height="28" viewBox="0 0 135.2716 291.7073" fill="white">
      <path d="m87.7896 53.271c13.1049 0 23.9709 10.2576 24.7375 23.3508.3564 6.0999-1.6229 11.7529-5.0409 16.2891.8575 2.1729 1.6064 4.1699 2.251 5.9961-9.3091 3.0762-20.5884 7.6074-24.3567 9.1479-.6042-1.1011-1.1774-2.1655-1.853-3.3386-11.5522-20.0562-33.6853-50.3088-71.3037-73.6877-3.7531-2.3315-8.6859-1.1804-11.0175 2.5732-2.3322 3.7524-1.1804 8.6853 2.572 11.0168 33.3844 20.7471 53.6615 47.771 64.6124 66.1646 3.205 5.3821 5.6067 9.9792 7.2937 13.4949.0513.1648.0134.332.0714.4956 1.001 2.8223 23.8037 69.9512-39.6094 144.6387-4.4727 5.2539-3.8281 13.1445 1.4355 17.6172 2.3486 1.9922 5.2246 2.9688 8.0859 2.9688 3.54 0 7.0605-1.4941 9.5312-4.4141 28.0048-32.9773 41.1841-64.9902 46.7474-92.1619l7.5092-.4358c-1.3733 23.7769-5.1587 51.8213-13.4949 82.9883-1.7822 6.6699 2.1777 13.5254 8.8428 15.3125 1.084.2832 2.1729.4199 3.2422.4199 5.5176 0 10.5713-3.6816 12.0654-9.2676 26.7462-99.9854 10.2673-169.5508 8.7946-175.3638-.0018-.0098.0012-.0171-.0006-.0269-.5225-2.4219-13.4326-59.9316-68.2275-105.2051-3.418-2.832-8.4521-2.3438-11.2646 1.0645s-2.334 8.4473 1.0693 11.2598c15.1532 12.5244 26.8073 26.1694 35.7751 39.1553.0214 0 .0409-.0073.0623-.0098.4933-.0293.9822-.0427 1.4699-.0427z"/>
      <path d="m89.0829 100.533c12.4042-.7251 21.8732-11.3696 21.1481-23.7769-.7263-12.4048-11.3727-21.8726-23.7769-21.1462-10.8612.636-19.4678 8.8721-20.9564 19.2371 7.4628 9.0857 13.3459 17.6855 17.8815 25.21 1.845.3685 3.7377.5907 5.7037.476z"/>
    </svg>
  </span>
);

const WarmUpDiscussionExerciseBoard = ({
  exerciseData, exerciseType: _exerciseType, onUpdate, isSelected, onSelect, onExpand,
  isExpanded: isExpandedProp, onClose,
  isStudent = false, myState = {}, otherState = {}, updateState = () => {},
}) => {
  const [isExpandedLocal, setIsExpandedLocal] = useState(false);
  const isExpanded = isExpandedProp !== undefined ? isExpandedProp : isExpandedLocal;
  const { questions, title, level } = exerciseData;

  if (!questions || !Array.isArray(questions)) {
    return (
      <div className="warm-up-discussion-board-error">
        <p>Error: Invalid Warm Up Discussion exercise data</p>
      </div>
    );
  }

  const handleExpand = () => {
    if (isExpandedProp === undefined) setIsExpandedLocal(true);
    if (onSelect) onSelect();
    if (onExpand) onExpand();
  };

  const handleClose = () => {
    if (isExpandedProp === undefined) setIsExpandedLocal(false);
    if (onClose) onClose();
  };

  return (
    <div className="warm-up-discussion-exercise-board">
      {!isExpanded ? (
        <div
          className={`warm-up-discussion-preview unified-exercise-preview wud-board-card${isSelected ? ' is-selected' : ''}`}
          onClick={handleExpand}
        >
          {WARM_UP_DISCUSSION_ICON}
          <div className="unified-preview-main">
            <div className="unified-preview-title">{title || 'Warm Up Discussion Exercise'}</div>
            <div className="unified-preview-meta">
              {questions.length} discussion questions · Level: {level || 'B1'}
            </div>
          </div>
          <button className="unified-preview-btn">
            Start Exercise
          </button>
        </div>
      ) : (
        <div className="warm-up-discussion-expanded">
          <WarmUpDiscussionExercise
            questions={questions}
            title={title}
            level={level}
            onClose={handleClose}
            updateAttributes={onUpdate}
            isStudent={isStudent}
            myState={myState}
            otherState={otherState}
            updateState={updateState}
          />
        </div>
      )}
    </div>
  );
};

export default WarmUpDiscussionExerciseBoard;
